<template>

  <div class="copy-products-page">
     <KTCodePreview v-bind:title="'Sao chép sản phẩm giữa doanh nghiệp'"
      > <template v-slot:preview
        > <b-row class="mb-5"
          > <b-col md="3"
            > <label class="font-weight-bolder"
              > Doanh nghiệp nguồn <span class="text-danger">*</span> </label
            > <b-form-select
              class="select-style"
              size="sm"
              v-model="sourceCompanyId"
              :options="companyOptions"
              value-field="id"
              text-field="name"
              @change="onSourceCompanyChanged"
            /> </b-col
          > <b-col md="3"
            > <label class="font-weight-bolder"
              > Doanh nghiệp đích <span class="text-danger">*</span> </label
            > <b-form-select
              class="select-style"
              size="sm"
              v-model="targetCompanyId"
              :options="targetCompanyOptions"
              value-field="id"
              text-field="name"
              @change="clearValidationResult"
            /> </b-col
          > <b-col md="6"
            > <label class="font-weight-bolder">Tìm kiếm sản phẩm</label>
            <div class="d-flex">
               <treeselect
                class="flex-grow-1"
                :load-options="loadOptions"
                :multiple="true"
                :async="true"
                :disabled="!sourceCompanyId"
                placeholder="Tìm theo tên, mã sản phẩm, mã vạch"
                retryText="Thử lại..."
                retryTitle="Nhấp thử lại"
                searchPromptText="Nhập để tìm kiếm..."
                loadingText="Đang tải..."
                noResultsText="Không có kết quả"
                :match-keys="['label', 'customLabel']"
                v-model="selectedProducts"
                :backspace-removes="false"
                :clearable="false"
                valueFormat="object"
                :max-height="200"
                > <label
                  slot="option-label"
                  slot-scope="{ node, labelClassName }"
                  :class="labelClassName"
                  class="border-bottom"
                  > <span
                    class="text-primary d-block px-0"
                    v-if="node.raw.label"
                    > {{ node.raw.label }} </span
                  > <b
                    v-if="node.raw.customLabel"
                    class="d-block px-0"
                    > {{ node.raw.customLabel }} </b
                  > </label
                > </treeselect
              > <b-button
                class="ml-2"
                style="height: 31px; width: 40px"
                variant="secondary"
                size="sm"
                v-b-tooltip.hover
                title="Thêm sản phẩm"
                @click="onAddProduct"
                :disabled="!sourceCompanyId"
                > <i class="fas fa-arrow-down"></i> </b-button
              >
            </div>
             </b-col
          > </b-row
        > <b-row class="mb-4"
          > <b-col
            > <b-button
              variant="primary"
              size="sm"
              class="mr-2"
              :disabled="!sourceCompanyId"
              @click="loadDefaultProducts"
              > Tải danh sách </b-button
            > <b-button
              variant="secondary"
              size="sm"
              @click="goBackToList"
              >Quay lại danh sách</b-button
            > </b-col
          > <b-col class="text-right"
            > <b-button
              variant="secondary"
              size="sm"
              class="font-weight-bolder mr-3"
              :disabled="!sourceCompanyId || isImporting"
              @click="onClickImportExcel"
              > <i
                style="font-size: 1rem"
                class="far fa-file-excel mr-1"
              ></i
              > Nhập SP từ excel </b-button
            > <span class="text-dark font-weight-bolder"
              >Đã chọn {{ selectedProductIds.length }} sản phẩm</span
            > <input
              ref="importExcelInput"
              type="file"
              accept=".xls,.xlsx"
              class="d-none"
              @change="handleImportExcel"
            /> </b-col
          > </b-row
        > <b-alert
          v-if="validationErrorMessages.length"
          variant="danger"
          show
          class="mb-3"
          >
          <div
            v-for="(item, idx) in validationErrorMessages"
            :key="`err-${idx}`"
          >
             {{ item }}
          </div>
           </b-alert
        > <b-alert
          v-if="validationConflictMessages.length"
          variant="warning"
          show
          class="mb-3"
          >
          <div class="font-weight-bolder mb-1">
             Danh sách sản phẩm bị trùng ở doanh nghiệp đích:
          </div>

          <div
            v-for="(item, idx) in validationConflictMessages"
            :key="`cf-${idx}`"
          >
             {{ item }}
          </div>
           </b-alert
        > <b-alert
          v-if="validationBarcodeWarnings.length"
          variant="info"
          show
          class="mb-3"
          >
          <div class="font-weight-bolder mb-1">Cảnh báo barcode:</div>

          <div
            v-for="(item, idx) in validationBarcodeWarnings"
            :key="`bw-${idx}`"
          >
             {{ item }}
          </div>
           </b-alert
        > <b-alert
          v-if="importInvalidMessages.length"
          variant="danger"
          show
          class="mb-3"
          >
          <div class="font-weight-bolder mb-1"> Dòng không hợp lệ từ file Excel: </div>

          <div
            v-for="(item, idx) in importInvalidMessages"
            :key="`import-err-${idx}`"
          >
             {{ item }}
          </div>
           </b-alert
        > <b-table
          :items="listProducts"
          :fields="fields"
          class="table-bordered table-hover"
          :busy="onLoading"
          responsive
          small
          > <template v-slot:table-busy
            > <vcl-table
              :speed="5"
              :animate="true"
              :columns="6"
            ></vcl-table
            > </template
          > <template v-slot:head(selected)
            > <b-form-checkbox
              v-model="checkAll"
              @change="toggleSelectAll"
            /> </template
          > <template v-slot:cell(selected)="row"
            > <b-form-checkbox
              v-model="row.item.selected"
              @change="syncSelectedProductIds"
            /> </template
          > <template v-slot:cell(imageUrl)="row"
            > <ProductImage :src="row.item.imageUrl" /> </template
          > </b-table
        >
        <div class="d-flex justify-content-end mt-4">
           <b-button
            variant="primary"
            size="sm"
            :disabled="isCopyDisabled || isCopying"
            @click="copyProducts"
            > Sao chép {{ selectedProductIds.length }} sản phẩm </b-button
          >
        </div>
         </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import ApiService from '@/core/services/api.service'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import { makeToastFaile, makeToastSuccess } from '@/utils/common'
  import { VclTable } from 'vue-content-loading'
  import ProductImage from '@/view/components/products/ProductImage.vue'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import xlsx from 'xlsx'

  export default {
    components: {
      KTCodePreview,
      ProductImage,
      VclTable,
      Treeselect,
    },
    data() {
      return {
        sourceCompanyId: null,
        targetCompanyId: null,
        onLoading: false,
        isCopying: false,
        isImporting: false,
        companyOptions: [],
        selectedProducts: [],
        listProducts: [],
        checkAll: false,
        fields: [
          {
            key: 'selected',
            label: '',
            thStyle: { textAlign: 'center', width: '5%' },
          },
          {
            key: 'imageUrl',
            label: 'Hình ảnh',
            thStyle: { textAlign: 'center', width: '10%' },
          },
          {
            key: 'productCode',
            label: 'Mã sản phẩm',
            thStyle: { color: 'rgb(24, 28, 50)' },
          },
          {
            key: 'productName',
            label: 'Tên sản phẩm',
            thStyle: { color: 'rgb(24, 28, 50)' },
          },
          {
            key: 'barCode',
            label: 'Mã vạch',
            thStyle: { color: 'rgb(24, 28, 50)' },
          },
        ],
        selectedProductIds: [],
        validationResult: null,
        importInvalidRows: [],
      }
    },
    computed: {
      targetCompanyOptions() {
        return this.companyOptions.filter((item) => item.id !== this.sourceCompanyId)
      },
      isCopyDisabled() {
        return (
          !this.sourceCompanyId || !this.targetCompanyId || this.selectedProductIds.length === 0
        )
      },
      validationErrorMessages() {
        return this.validationResult?.errors || []
      },
      validationBarcodeWarnings() {
        return this.validationResult?.barcodeWarnings || []
      },
      validationConflictMessages() {
        const conflicts = this.validationResult?.conflicts || {}
        const codeConflicts = (conflicts.code || []).map((item) => `Trùng mã sản phẩm: ${item}`)
        const nameConflicts = (conflicts.name || []).map((item) => `Trùng tên sản phẩm: ${item}`)
        const barcodeConflicts = (conflicts.barCode || []).map((item) => `Trùng mã vạch: ${item}`)
        return [...codeConflicts, ...nameConflicts, ...barcodeConflicts]
      },
      importInvalidMessages() {
        return this.importInvalidRows.map((row) => {
          const rowNo = row.rowIndex || row.index || '-'
          const msg = row.message || row.error || row.reason || 'Dữ liệu không hợp lệ'
          return `Dòng ${rowNo}: ${msg}`
        })
      },
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Sản phẩm', route: '/products' },
        { title: 'Sao chép sản phẩm' },
      ])
      this.fetchCompanies()
    },
    methods: {
      goBackToList() {
        this.$router.push({ name: 'list-products' })
      },
      clearValidationResult() {
        this.validationResult = null
      },
      clearImportValidationResult() {
        this.importInvalidRows = []
      },
      onSourceCompanyChanged() {
        this.targetCompanyId = null
        this.selectedProducts = []
        this.listProducts = []
        this.selectedProductIds = []
        this.checkAll = false
        this.clearValidationResult()
        this.clearImportValidationResult()
      },
      syncSelectedProductIds() {
        this.selectedProductIds = this.listProducts
          .filter((item) => item.selected)
          .map((item) => item.id)
        this.checkAll =
          this.listProducts.length > 0 &&
          this.selectedProductIds.length === this.listProducts.length
        this.clearValidationResult()
      },
      toggleSelectAll() {
        this.listProducts = this.listProducts.map((item) => ({
          ...item,
          selected: this.checkAll,
        }))
        this.syncSelectedProductIds()
      },
      onClickImportExcel() {
        if (!this.sourceCompanyId) {
          makeToastFaile('Vui lòng chọn doanh nghiệp nguồn trước khi import')
          return
        }
        this.$refs.importExcelInput.click()
      },
      getExcelFieldValue(row, fields) {
        for (const field of fields) {
          const value = row[field]
          if (value !== undefined && value !== null && `${value}`.trim() !== '') {
            return `${value}`.trim()
          }
        }
        return ''
      },
      parseExcelRows(file) {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader()
          fileReader.onload = (ev) => {
            try {
              const workbook = xlsx.read(ev.target.result, { type: 'binary' })
              const sheetName = workbook.SheetNames[0]
              const rows = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName], {
                blankRows: false,
                defval: '',
              })
              resolve(rows)
            } catch (error) {
              reject(error)
            }
          }
          fileReader.onerror = () => reject(new Error('Không thể đọc file Excel'))
          fileReader.readAsBinaryString(file)
        })
      },
      mapExcelRowsToProducts(rows) {
        const listProduct = []
        rows.forEach((row, index) => {
          const id = this.getExcelFieldValue(row, ['ID sản phẩm', 'id', 'ID'])
          const productCode = this.getExcelFieldValue(row, [
            'Mã sản phẩm',
            'productCode',
            'ProductCode',
          ])
          const productName = this.getExcelFieldValue(row, [
            'Tên sản phẩm',
            'productName',
            'ProductName',
          ])
          const barCode = this.getExcelFieldValue(row, ['Mã vạch', 'barCode', 'Barcode', 'BarCode'])

          if (!id && !productCode && !barCode && !productName) {
            return
          }

          listProduct.push({
            rowIndex: index + 2,
            id,
            productCode,
            productName,
            barCode,
          })
        })
        return listProduct
      },
      async validateImportProducts(listProduct) {
        const query = this.sourceCompanyId ? `?companyId=${this.sourceCompanyId}` : ''
        const { data } = await ApiService.post(
          `v1/product-search/validate-import-products${query}`,
          {
            listProduct,
          },
        )
        return data?.data || {}
      },
      mergeProductsToList(validProducts) {
        const existedIds = new Set(this.listProducts.map((item) => item.id))
        const mappedProducts = (validProducts || [])
          .filter((item) => item.id && !existedIds.has(item.id))
          .map((item) => ({
            id: item.id,
            productCode: item.productCode || '',
            productName: item.productName || '',
            barCode: item.barCode || '',
            imageUrl: item.imageUrl || '',
            selected: false,
          }))

        this.listProducts = [...mappedProducts, ...this.listProducts]
        this.syncSelectedProductIds()
      },
      async handleImportExcel(event) {
        const file = event?.target?.files?.[0]
        if (!file) {
          return
        }
        if (!/\.(xls|xlsx)$/i.test(file.name)) {
          makeToastFaile('Vui lòng chọn file Excel có đuôi .xls hoặc .xlsx')
          event.target.value = ''
          return
        }
        this.isImporting = true
        this.clearImportValidationResult()
        try {
          const rows = await this.parseExcelRows(file)
          const listProduct = this.mapExcelRowsToProducts(rows)
          if (!listProduct.length) {
            makeToastFaile('File excel không có dữ liệu hợp lệ')
            return
          }
          const result = await this.validateImportProducts(listProduct)
          const validProducts = result.validProducts || []
          this.importInvalidRows = result.invalidRows || []
          this.mergeProductsToList(validProducts)

          const totalValidRows = result.summary?.totalValidRows || validProducts.length
          const totalInvalidRows = result.summary?.totalInvalidRows || this.importInvalidRows.length
          makeToastSuccess(`Import thành công ${totalValidRows} dòng hợp lệ`)
          if (totalInvalidRows > 0) {
            makeToastFaile(`Có ${totalInvalidRows} dòng không hợp lệ, vui lòng kiểm tra cảnh báo`)
          }
        } catch (error) {
          makeToastFaile(error?.response?.data?.message || 'Import file Excel thất bại')
        } finally {
          this.isImporting = false
          event.target.value = ''
        }
      },
      async fetchCompanies() {
        const params = { page: 1, limit: 1000, name: '', code: '' }
        try {
          const { data } = await ApiService.query('v1/companies', { params })
          const dataset = data?.data?.dataset || []
          this.companyOptions = [
            { id: null, name: 'Chọn doanh nghiệp' },
            ...dataset.map((item) => ({
              id: item.id,
              name: item.name,
            })),
          ]
        } catch (error) {
          makeToastFaile(error?.response?.data?.message || 'Không thể tải danh sách doanh nghiệp')
        }
      },
      async searchProductsByCompany(searchText = '') {
        const params = {
          companyId: this.sourceCompanyId,
          searchText,
        }
        this.onLoading = true
        try {
          const { data } = await ApiService.query('v1/product-search/by-company', { params })
          return data?.data || []
        } catch (error) {
          makeToastFaile(error?.response?.data?.message || 'Không thể tải danh sách sản phẩm')
          return []
        } finally {
          this.onLoading = false
        }
      },
      async loadOptions({ action, searchQuery, callback }) {
        if (action !== ASYNC_SEARCH) {
          return
        }
        if (!this.sourceCompanyId) {
          callback(null, [])
          return
        }
        const products = await this.searchProductsByCompany((searchQuery || '').trim())
        const options = products.map((item) => ({
          id: item.id,
          label: item.productName || '',
          customLabel: `${item.productCode || ''}${item.barCode ? ` - ${item.barCode}` : ''}`,
          productCode: item.productCode || '',
          productName: item.productName || '',
          barCode: item.barCode || '',
          imageUrl: item.imageUrl || '',
          selected: true,
        }))
        callback(null, options)
      },
      onAddProduct() {
        if (!this.selectedProducts.length) {
          makeToastFaile('Vui lòng chọn sản phẩm muốn thêm')
          return
        }
        const existedIds = new Set(this.listProducts.map((item) => item.id))
        const newProducts = this.selectedProducts.filter((item) => !existedIds.has(item.id))

        if (!newProducts.length) {
          makeToastFaile('Sản phẩm đã có trong danh sách')
          return
        }
        this.listProducts = [...newProducts, ...this.listProducts]
        this.selectedProducts = []
        this.syncSelectedProductIds()
      },
      async loadDefaultProducts() {
        if (!this.sourceCompanyId) {
          makeToastFaile('Vui lòng chọn doanh nghiệp nguồn')
          return
        }
        const products = await this.searchProductsByCompany('')
        const existedIds = new Set(this.listProducts.map((item) => item.id))
        const mappedProducts = products
          .filter((item) => !existedIds.has(item.id))
          .map((item) => ({
            id: item.id,
            productCode: item.productCode || '',
            productName: item.productName || '',
            barCode: item.barCode || '',
            imageUrl: item.imageUrl || '',
            selected: false,
          }))
        this.listProducts = [...mappedProducts, ...this.listProducts]
        this.syncSelectedProductIds()
      },
      getCopyPayload(productIds) {
        return {
          sourceCompanyId: this.sourceCompanyId,
          targetCompanyId: this.targetCompanyId,
          productIds,
        }
      },
      async validateBeforeCopy() {
        const payload = this.getCopyPayload(this.selectedProductIds)
        try {
          const { data } = await ApiService.post('v1/product-transfer/validate', payload)
          this.validationResult = data?.data || null
          return this.validationResult
        } catch (error) {
          this.clearValidationResult()
          makeToastFaile(error?.response?.data?.message || 'Validate dữ liệu sao chép thất bại')
          return null
        }
      },
      hasValidationIssue(result) {
        if (!result) {
          return true
        }
        if (result.isValid === false) {
          return true
        }
        if ((result.errors || []).length > 0) {
          return true
        }
        return false
      },
      async copyProducts() {
        if (this.isCopyDisabled) {
          return
        }
        this.isCopying = true
        const validateResult = await this.validateBeforeCopy()
        if (this.hasValidationIssue(validateResult)) {
          this.isCopying = false
          makeToastFaile('Dữ liệu chưa hợp lệ, vui lòng kiểm tra lỗi trước khi sao chép')
          return
        }

        const productIdsForCopy = validateResult.expandedProductIds || this.selectedProductIds
        const payload = this.getCopyPayload(productIdsForCopy)
        try {
          const { data } = await ApiService.post('v1/product-transfer/copy', payload)
          const responseData = data?.data || {}
          const warningCount = (responseData.barcodeWarnings || []).length
          makeToastSuccess(
            `${data?.message || 'Sao chép sản phẩm thành công'} (Tạo mới: ${responseData.totalCreated || 0})`,
          )
          if (warningCount > 0) {
            this.$bvToast.toast(`Có ${warningCount} barcode được sinh mới khi copy`, {
              title: 'Cảnh báo barcode',
              variant: 'warning',
              solid: true,
            })
          }
          this.goBackToList()
        } catch (error) {
          makeToastFaile(error?.response?.data?.message || 'Sao chép sản phẩm thất bại')
        } finally {
          this.isCopying = false
        }
      },
    },
  }
</script>

<style scoped>
  .copy-products-page .table th,
.copy-products-page .table td {
  vertical-align: middle;
}
</style>

